import { Lock, Construction } from 'lucide-react';
import { Card, Button } from '@tokenforge/design-system';

interface Props {
  title: string;
  description?: string;
  variant?: 'placeholder' | 'max-stub';
}

export function EmptyPage({ title, description, variant = 'placeholder' }: Props) {
  const isMaxStub = variant === 'max-stub';
  const Icon = isMaxStub ? Lock : Construction;
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <Card className="max-w-md text-center">
        <Icon size={48} className="mx-auto mb-4 text-foreground/40" aria-hidden="true" />
        <h2 className="text-xl font-semibold mb-2">{title}</h2>
        {description && <p className="text-foreground/70 mb-6">{description}</p>}
        {isMaxStub && <Button variant="secondary">了解 Enterprise MAX</Button>}
      </Card>
    </div>
  );
}
